import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actionCreators } from 'react/api/actions/routeSurveyModal';
import * as selectors from 'react/api/selectors/routeSurveyModal';
import Loading from 'react/components/Loading';

class SurveyAnswerEntity extends React.Component {
  componentDidMount() {
    const { surveyQuestion, fetchEntityAnswerAction, entityAnswers, routeId, stopId } = this.props;
    if (!entityAnswers?.size) {
      fetchEntityAnswerAction(routeId, stopId, surveyQuestion);
    }
  }

  render() {
    const { entityAnswers, isLoading } = this.props;
    return (
      <div className="route-survey-modal__survey-answer-entity">
        {
          isLoading ? <Loading height="100%" /> : (
            <ul>
              {
                entityAnswers.map((entityAnswer) => (
                  <li key={entityAnswer.get('id')}>{entityAnswer.get('description') || entityAnswer.get('key')}</li>
                ))
              }
            </ul>
          )
        }
      </div>
    );
  }
}

SurveyAnswerEntity.propTypes = {
  // state
  routeId: PropTypes.string.isRequired,
  stopId: PropTypes.string,
  surveyQuestion: PropTypes.object.isRequired,
  entityAnswers: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  // actions
  fetchEntityAnswerAction: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  entityAnswers: selectors.getEntityAnswers(state, ownProps),
  isLoading: selectors.getIsLoadingEntityAnswer(state, ownProps)
});

const mapDispatchToProps = {
  fetchEntityAnswerAction: actionCreators.fetchEntityAnswer
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyAnswerEntity);
